import { createTheme } from '@mui/material/styles';

import { DEFAULT_THEME, hexToRgb } from './utils/orgConfig';

// colors = { primary: {50..900}, secondary: {50..900} } จาก org/theme.json (ไม่ส่ง = สีเริ่มต้น)
export const buildTheme = (colors = DEFAULT_THEME) => createTheme({
  typography: {
    fontFamily: [
      'Prompt',
      'sans-serif',
    ].join(','),
    h1: { fontWeight: 600 },
    h2: { fontWeight: 600 },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    button: { textTransform: 'none', fontWeight: 500 },
  },
  shape: {
    borderRadius: 12, // More rounded corners generally
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 640,
      md: 768,
      lg: 1024,
      xl: 1280,
    },
  },
  palette: {
    mode: 'light',
    primary: {
      main: colors.primary[500], // INDIGO 500
      light: colors.primary[400],
      dark: colors.primary[700],
      contrastText: '#ffffff',
    },
    secondary: {
      main: colors.secondary[500], // ORANGE 500
      light: colors.secondary[400],
      dark: colors.secondary[600],
      contrastText: '#ffffff',
    },
    background: {
      default: process.env.NODE_ENV === 'development' ? '#fefce8' : '#f3f4f6',
      paper: '#ffffff',
    },
    text: {
      primary: '#111827', // Gray 900
      secondary: '#6b7280', // Gray 500
    },
    success: {
      main: '#10b981', // Emerald 500
    },
    error: {
      main: '#ef4444', // Red 500
    },
    warning: {
      main: '#f59e0b', // Amber 500
    },
    info: {
      main: '#3b82f6', // Blue 500
    },
    // Custom colors found in old theme, kept for compatibility but remapped
    amber: { main: '#f59e0b' },
    cyan: { main: '#06b6d4' },
    indigo: { main: colors.primary[500] },
    gray: { main: '#9ca3af', light: '#e5e7eb' },
    lightGreen: { main: '#86efac' },
    black1: { main: '#000000' },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '8px 24px',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: `0 4px 12px rgba(${hexToRgb(colors.primary[500]).join(', ')}, 0.2)`, // Soft colored shadow on hover
          },
        },
        containedPrimary: {
          '&:hover': {
            backgroundColor: colors.primary[600],
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)', // Tailwind shadow-md compatible
          backgroundImage: 'none',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        elevation1: {
          boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
        },
        elevation2: {
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        },
        elevation3: {
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
        }
      }
    }
  },
});

export default buildTheme();
